import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-6" };
const _hoisted_2 = { class: "flex flex-col gap-3" };
const _hoisted_3 = { class: "flex items-center gap-1.5" };
const _hoisted_4 = { class: "text-base font-bold text-(--text-text-heading)" };
const _hoisted_5 = {
    key: 0,
    class: "flex flex-col gap-3.5"
};
const _hoisted_6 = {
    key: 1,
    class: "text-sm text-(--text-text-body-subtle)"
};
const _hoisted_7 = { class: "flex flex-col gap-3" };
const _hoisted_8 = { class: "flex items-center gap-1.5" };
const _hoisted_9 = { class: "text-base font-bold text-(--text-text-heading)" };
const _hoisted_10 = {
    key: 0,
    class: "flex flex-col gap-3.5"
};
const _hoisted_11 = {
    key: 1,
    class: "text-sm text-(--text-text-body-subtle)"
};
import { computed } from "vue";
import { Button, Tooltip } from "@eudonet/opal";
import { useI18n } from "vue-i18n";
import ContactChannelRow from "./ContactChannelRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactCoordonneesSection',
    props: {
        channels: {},
        canEdit: { type: Boolean },
        readOnly: { type: Boolean }
    },
    emits: ["editChannel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const phones = computed(() => props.channels
            .filter((c) => c.type === "Phone")
            .sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary)));
        const emails = computed(() => props.channels
            .filter((c) => c.type === "Email")
            .sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary)));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[0] || (_cache[0] = _createElementVNode("i", {
                            class: "ri-phone-line text-xl text-(--text-text-heading)",
                            "aria-hidden": "true"
                        }, null, -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("contact.detail.contactInformation.telephonesTitle")), 1 /* TEXT */)
                    ]),
                    (phones.value.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phones.value, (channel) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: channel.id
                                }, [
                                    _createVNode(ContactChannelRow, { channel: channel }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                        (!props.readOnly)
                                            ? {
                                                name: "actions",
                                                fn: _withCtx(() => [
                                                    _createVNode(_unref(Tooltip), {
                                                        text: _unref(t)('common.permissions.noEditRights'),
                                                        disabled: props.canEdit,
                                                        tabindex: !props.canEdit ? 0 : undefined
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(Button), {
                                                                variant: "secondary",
                                                                size: "xs",
                                                                "icon-only": true,
                                                                "icon-left": "ri-pencil-line",
                                                                "aria-label": _ctx.$t('contact.detail.editPhone.title'),
                                                                disabled: !props.canEdit,
                                                                onClick: ($event) => (emit('editChannel', channel))
                                                            }, null, 8 /* PROPS */, ["aria-label", "disabled", "onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "disabled", "tabindex"])
                                                ]),
                                                key: "0"
                                            }
                                            : undefined
                                    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["channel"])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("contact.detail.contactInformation.noPhone")), 1 /* TEXT */))
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _cache[1] || (_cache[1] = _createElementVNode("i", {
                            class: "ri-mail-line text-xl text-(--text-text-heading)",
                            "aria-hidden": "true"
                        }, null, -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("contact.detail.contactInformation.emailsTitle")), 1 /* TEXT */)
                    ]),
                    (emails.value.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emails.value, (channel) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: channel.id
                                }, [
                                    _createVNode(ContactChannelRow, { channel: channel }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                        (!props.readOnly)
                                            ? {
                                                name: "actions",
                                                fn: _withCtx(() => [
                                                    _createVNode(_unref(Tooltip), {
                                                        text: _unref(t)('common.permissions.noEditRights'),
                                                        disabled: props.canEdit,
                                                        tabindex: !props.canEdit ? 0 : undefined
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(Button), {
                                                                variant: "secondary",
                                                                size: "xs",
                                                                "icon-only": true,
                                                                "icon-left": "ri-pencil-line",
                                                                "aria-label": _ctx.$t('contact.detail.editEmail.title'),
                                                                disabled: !props.canEdit,
                                                                onClick: ($event) => (emit('editChannel', channel))
                                                            }, null, 8 /* PROPS */, ["aria-label", "disabled", "onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "disabled", "tabindex"])
                                                ]),
                                                key: "0"
                                            }
                                            : undefined
                                    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["channel"])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t("contact.detail.contactInformation.noEmail")), 1 /* TEXT */))
                ])
            ]));
        };
    }
});
